// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"c9fe0658356b73c27f7b","339":"491bd18f6064cdfdd2f6"}[chunkId] + ".js";
};